export const amountNumbers = 15;
export const rows = 4;
export const cols = 4;
